var el_paymentMethods = $('[name="payment_method_id"]'),
    el_toggleEmailCol = $('.toggle-email-col'),
    paymentMethodId = el_toggleEmailCol.data('payment_method_id'),
    el_toggleEmailColSiblings = el_toggleEmailCol.siblings();

if( el_paymentMethods.length ){
    el_paymentMethods.on('change', function () {
        if ($(this).val() == paymentMethodId) {
            el_toggleEmailCol.show();
            el_toggleEmailColSiblings.removeClass('col-sm-12').addClass('col-sm-8');
        } else {
            el_toggleEmailCol.hide();
            el_toggleEmailColSiblings.removeClass('col-sm-8').addClass('col-sm-12');
        }
    });

    el_paymentMethods.trigger('change');
}else{
    el_toggleEmailCol.hide();
    el_toggleEmailColSiblings.removeClass('col-sm-8').addClass('col-sm-12');
}

